import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterVacancyMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Vacant Beds"
    subtitle=""
    tooltip="Beds genuinely free to offer someone tonight."
    field="vacant_beds"
  />
);
